module.exports = __webpack_public_path__ + "img/bg_05.772f6f04.png";